import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router";
import {AppPage} from "../_common/components/app-page";
import {t} from "../_i18n";
import {Fragment, h} from "preact";
import {Card, CF, F} from "../_common/layout";
import {useEffect, useState} from "preact/hooks";
import Banner from "../_common/components/Banner";
import './convocation-resignations.scss';
import {Link} from "react-router-dom";


export const ConvocationResignations = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [selectedOption, setSelectedOption] = useState('');
    const { convocationResignations, student_meta } = useSelector(state => ({
        convocationResignations: state.convocationResignations,
        // student_meta: state.status.student_meta
    }));

    const hasConvocationData = convocationResignations && Object.keys(convocationResignations).length > 0;
    const isConvocationResignationsExtraordinary = hasConvocationData && convocationResignations.is_extraordinary;

    return <AppPage
        name='convocation-resignations'
        back={history.back}
        class="max-width-980">
        <F className="max-width-980 convocation-resignations">
            {!hasConvocationData ? (
                <Banner color="warning" icon="warning" background="warning">
                    <div>{t('En este momento no hay renuncias de convocatorias disponibles para ti.')}</div>
                </Banner>
            ) : (
                <div>
                    <div className="back breadcrumb-item cursor-pointer m-bottom" onClick={() => history.goBack()}>
                        <i className="far fa-arrow-left p-left-half no-margin-left m-r-half" aria-hidden="true"></i>
                        {t('Volver')}
                    </div>

                    {!isConvocationResignationsExtraordinary ?
                        (
                            <CF>
                                <Card smOnly={true} class="p-x2-bottom">
                                    <h1 className='hero m-top m-bottom'>{t('Renuncia a Convocatorias')}</h1>
                                    <p dangerouslySetInnerHTML={{__html: t('Si no puedes presentarte a una convocatoria')}}></p>
                                    <h2 class="m-top-x2">{t('¿Cuándo puedes pedir la renuncia?')}</h2>
                                    <p class="m-top">{t('La renuncia puede solicitarse hasta un mes antes de la fecha de la convocatoria, y solo en situaciones justificadas como:')}</p>
                                    <div className="doted-list m-top-half">
                                        <ul>
                                            <li>{t('Enfermedad prolongada o accidente del alumno/a.')}</li>
                                            <li>{t('Obligaciones personales o familiares que impidan la dedicación al estudio (previa valoración por parte de la Dirección del centro).')}</li>
                                            <li>{t('Ocupación laboral, tanto por cuenta propia como ajena.')}</li>
                                        </ul>
                                    </div>
                                    <h2 class="m-top-x2">{t('Recuerda estos puntos importantes:')}</h2>
                                    <div className="doted-list m-top-half">
                                        <ul>
                                            <li dangerouslySetInnerHTML={{__html: t('Necesitas presentar documentación que justifique tu solicitud.')}}></li>
                                            <li dangerouslySetInnerHTML={{__html: t('La Dirección del centro revisará tu solicitud y te dará una respuesta en los plazos establecidos.')}}></li>
                                            <li dangerouslySetInnerHTML={{__html: t('No se devolverán el importe abonado si decides renunciar.')}}></li>
                                            <li dangerouslySetInnerHTML={{__html: t('Si no superas el módulo en el curso, tendrás que rematricularte.')}}></li>
                                        </ul>
                                    </div>
                                    <Banner color="info" background="info" class="m-top-x2">
                                        <span> {t('Si deseas solicitar la renuncia, puedes hacerlo a través del siguiente apartado: ')}</span>
                                        <p className="m-bottom-half m-top-half">
                                            <Link className='font-bold hover-line text-responsive' to='/convocation-resignations-form'>{t('Solicitar renuncia')}</Link>
                                        </p>
                                        <span class="m-top"> {t('¡Asegúrate de tener toda la información clara antes de enviar tu solicitud! 😊')}</span>
                                    </Banner>

                                </Card>
                            </CF>
                        ) : (
                            <CF>
                                <Card smOnly={true} class="p-x2-bottom">
                                    <h1 className='hero m-top m-bottom'>{t('Renuncia a la Convocatoria Extraordinaria')}</h1>
                                    <p dangerouslySetInnerHTML={{__html: t('Si no puedes presentarte a la próxima convocatoria extraordinaria')}}></p>
                                    <div className="doted-list m-top-half">
                                        <ul>
                                            <li dangerouslySetInnerHTML={{__html: t('Plazo: Dispones de 2 días hábiles')}}></li>
                                            <li dangerouslySetInnerHTML={{__html: t('Motivo de renuncia: Puedes solicitar la renuncia en casos justificados')}}></li>
                                        </ul>
                                    </div>
                                    <p dangerouslySetInnerHTML={{__html: t('Deberás presentar la documentación justificativa correspondiente que acredite la causa')}}></p>
                                    <Banner color="info" background="info" class="m-top-x2">
                                        <span> {t('Puedes hacer tu solicitud desde el siguiente enlace:')}</span>
                                        <span className="m-top-half m-l-half">
                                            <Link className='font-bold hover-line text-responsive' to='/convocation-resignations-form'>{t('Solicitar renuncia')}</Link>
                                        </span>
                                    </Banner>

                                </Card>
                            </CF>
                        )
                    }

                </div>
            )}
        </F>
    </AppPage>
}
